import {OrgCustomizedConfiguration} from '../OrgCustomizedConfiguration';
import ProductLabelImg from './images/product-label-example.png'
import MouthDiagramImg from './images/mouth-diagram.svg'
import IconImg from './images/nobel_icon.png'
import translations from '../../../localization/build/nobel.json'
import Theme from "./Theme";
import ThirdPartyProductError from "./ThirdPartyProductError";

const configuration: OrgCustomizedConfiguration = {
    OrgIdentifier: 'Nobel',
    OrgName: 'Nobel Biocare',
    HostsConfiguration: {
        'nobelcomplaints.dev.platform.dental': {
            StoreUrl: 'https://nobi-mg2.dev.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: "Development"
        },
        'nobelcomplaints.sta.platform.dental': {
            StoreUrl: 'https://nobi-mg2.sta.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: "Staging",
            GoogleAnalytics: {
                Id: 'GTM-P8QT3949',
                Options: {
                    gtm_auth: 'LRfAHcJVnfLqv0OaKp6Cog',
                    gtm_preview: 'env-3',
                    gtm_cookies_win: 'x'
                }
            }
        },
        'nobelcomplaints.nobelbiocare.com': {
            StoreUrl: 'https://store.nobelbiocare.com',
            IsDevelopmentEnvironment: false,
            Environment: "Production",
            GoogleAnalytics: {
                Id: 'GTM-P8QT3949',
            }
        },
        'localhost': {
            StoreUrl: 'https://nobi-mg2.dev.platform.dental',
            IsDevelopmentEnvironment: true,
            Environment: "Local",
        }
    },
    IconImage: IconImg,
    MuiTheme: Theme,
    ImageMap: {
        ProductLabel: {
            src: ProductLabelImg,
            style: {
                marginTop: 'auto',
                alignSelf: 'center',
            },
            sx: {
                width: {xs: 290, sm: 320},
                height: {xs: 308, sm: 340},
                mt: {md: 5},
            }
        },
        MouthDiagram: {
            src: MouthDiagramImg,
        }
    },
    Translations: translations,
    SupportedLanguages: new Set(['en', 'zh', 'de', 'es', 'fr', 'it', 'ja', 'pt', 'ru']),
    QuestionConfigurations: {
        patient_weight: {
            show: false,
            required: false
        },
        browse_for_photos: {
            show: true,
            required: true
        }
    },
    ItemSearchConfiguration: {
        useItemDescriptionSearch: (s) => /\D/.test(s) && s.length >= 3,
        useItemIdSearch: (s) => !/\D/.test(s) && s.length >= 4,
        useActiveProductSearch: (s) => s.length >= 3
    },
    GuestCountryWhitelist: [
        { countryCode: "az", languageCode: "en" },
        { countryCode: "cl", languageCode: "es" },
        { countryCode: "cn", languageCode: "zh" },
        { countryCode: "cr", languageCode: "es" },
        { countryCode: "hr", languageCode: "hr" },
        { countryCode: "cz", languageCode: "cs" },
        { countryCode: "eg", languageCode: "ar" },
        { countryCode: "ee", languageCode: "et" },
        { countryCode: "gr", languageCode: "el" },
        { countryCode: "in", languageCode: "en" },
        { countryCode: "iq", languageCode: "ar" },
        { countryCode: "il", languageCode: "he" },
        { countryCode: "jo", languageCode: "ar" },
        { countryCode: "jp", languageCode: "ja" },
        { countryCode: "kw", languageCode: "ar" },
        { countryCode: "lv", languageCode: "lv" },
        { countryCode: "lb", languageCode: "ar" },
        { countryCode: "lt", languageCode: "lt" },
        { countryCode: "mx", languageCode: "es" },
        { countryCode: "om", languageCode: "ar" },
        { countryCode: "pl", languageCode: "pl" },
        { countryCode: "qa", languageCode: "ar" },
        { countryCode: "ro", languageCode: "ro" },
        { countryCode: "sa", languageCode: "ar" },
        { countryCode: "sg", languageCode: "en" },
        { countryCode: "za", languageCode: "en" },
        { countryCode: "tw", languageCode: "zh" },
        { countryCode: "tr", languageCode: "tr" },
        { countryCode: "ua", languageCode: "uk" },
        { countryCode: "ae", languageCode: "ar" },
        { countryCode: "pr", languageCode: "es" },
    ],
    ThirdPartyErrorComponent: ThirdPartyProductError
}

export default configuration
